<template>
<!-- Navigation -->
    <nav class="nav">
        <div class="logo-container">
            <img src="../assets/images/pabu-logo.png" alt="Pabu Logo" class="logo">
        </div>
        <a href="#waitlist" class="nav-cta">Join Waitlist</a>
    </nav>  
</template>

<script>
/*
export default {
  data() {
    return {
      isNavOpen: false,
      menuItems: [
        { name: "Home", link: "/", active: true },
        { name: "About", link: "/about", active: false },
        { name: "Values", link: "/values", active: false },
        { name: "Services", link: "/services", active: false },
        { name: "Careers", link: "/careers", active: false },
      ],
    };
  },
  methods: {
    toggleNav() {
      this.isNavOpen = !this.isNavOpen;
      this.toggleAriaExpanded();
    },
    toggleAriaExpanded() {
      const csUL = document.querySelector("#cs-expanded");
      if (csUL) {
        csUL.setAttribute("aria-expanded", this.isNavOpen.toString());
      }
    },
  },
};
*/
</script>

<style scoped>

</style>
